module.exports = new __parcel__URL__("NoProductAccess.a65d0283.svg").toString();